
import { Options, Vue, prop } from "vue-class-component";

class Props {
  variant = prop<"value" | "progress">({ default: "progress" });
  label = prop<string>({ default: "" });
  icon = prop<string>({ default: "" });
  value = prop<string | number>({ default: "" });
  completed = prop<number>({ default: 0 });
  total = prop<number>({ default: 0 });
  linearClass = prop<string>({ default: "linear-green" });
  iconColor = prop<string>({ default: "text-green-lp-400" });
}

@Options({})
export default class SummaryCard extends Vue.with(Props) {
  get isCompleted() {
    return this.completed >= this.total && this.total > 0;
  }
  get containerLinearClass() {
    if (this.variant === "value") return this.linearClass;
    // progress variant
    return this.isCompleted ? "linear-green" : "linear-red";
  }
  get iconColorClass() {
    if (this.variant === "value") return this.iconColor;
    return this.isCompleted ? "text-green-lp-400" : "text-red-lp-100";
  }
}
